<template>
    <div>
        <template>
            <div class="side-margin">
                <v-row class="d-flex align-center">
                    <!-- Image Column: auto-width, aligned right -->
                    <v-col cols="12" class="d-flex justify-center justify-md-end py-2" style="max-width: fit-content;">
                        <v-img v-if="child_data[0].photo_path" :src="awspath + child_data[0].photo_path" width="90"
                            height="120" cover style="border: 1px solid black; border-radius: 4px;" />
                    </v-col>

                    <!-- Form Column: take 5 cols on md+, full on mobile -->
                    <v-col cols="12" sm="12" md="5" class="py-2">
                        <v-combobox required dense rounded :items="ay_list" v-model="ay" label="Academic Year" outlined
                            item-text="ay" item-value="id" @change="call2" class="mb-2" />

                        <v-autocomplete required dense rounded :items="learner_list" v-model="learner"
                            item-text="learner" item-value="id" label="Please Select Student" outlined hide-details
                            @change="call2" />
                    </v-col>
                </v-row>

                <v-card class="pa-4 mt-7 elevation-2">
                    <v-simple-table class="table-styled">
                        <template v-slot:default>
                            <tbody>
                                <template v-for="item in child_data">
                                    <tr :key="item.id + '-main'" class="row-bordered">
                                        <td class="cell-box">
                                            <strong>Registration No.</strong><br><br>{{ item.grno }}
                                        </td>
                                        <td class="cell-box">
                                            <strong>Status</strong><br><br>
                                            <v-chip :color="item.status === 0 ? 'green' : 'red'" text-color="white"
                                                small>
                                                {{ item.status === 0 ? 'Active' : 'In-Active' }}
                                            </v-chip>
                                        </td>
                                        <td class="cell-box">
                                            <strong>Grade/Division/Roll No.</strong><br><br>{{ item.std_div_rno }}
                                        </td>
                                        <td class="cell-box">
                                            <strong>Mobile No.</strong><br><br>{{ item.mobile_no }}
                                        </td>
                                        <td class="cell-box">
                                            <strong>Email</strong><br><br>{{ item.email }}
                                        </td>
                                        <td class="cell-box">
                                            <strong>Date Of Birth</strong><br><br>{{ item.dob }}
                                        </td>
                                    </tr>

                                    <tr :key="item.id + '-sub'" class="row-bordered">
                                        <td class="cell-box">
                                            <strong>Today's Attendance</strong><br><br>
                                            <v-icon v-if="item.today_attendance === true"
                                                color="success">mdi-check-circle</v-icon>
                                            <v-icon v-else-if="item.today_attendance === false"
                                                color="red">mdi-close-circle</v-icon>
                                            <span v-else style="color: #101010; font-weight: bold;">--</span>
                                        </td>
                                        <td class="cell-box">
                                            <strong>Bus Number</strong><br><br><span v-if="item.bus_number">{{
                                                item.bus_number }}</span><span v-else>--</span>
                                        </td>
                                        <td class="cell-box">
                                            <strong>Driver Contact</strong><br><br>{{ item.driver_contact }}
                                        </td>
                                        <td class="cell-box">
                                            <strong>Pickup-Drop Timing</strong><br><br>{{ item.pickup_time }} -- {{
                                            item.drop_time }}
                                        </td>
                                        <td class="cell-box">
                                            <strong>Live GPS Tracking</strong><br><br>
                                            <a :href="item.bus_url" target="_blank" v-if="item.bus_url != null">
                                                <v-icon class="mr-2 v-icon-size" color="green">mdi-map-marker</v-icon>
                                            </a>
                                            <span v-else style="opacity: 0.5;">--</span>
                                        </td>
                                        <td class="cell-box">
                                            <strong>Class Teacher</strong><br><br>{{ item.class_teacher_name }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>

                <v-card v-if="softCards.length > 0" class="mt-6 pa-2">
                    <div class="d-flex flex-wrap justify-center" style="gap: 12px;">
                        <div v-for="(card, index) in softCards" :key="index" class="responsive-card"
                            @click="handleCardClick(card)">
                            <v-hover v-slot="{ hover }">
                                <v-card flat class="pa-4 text-center d-flex flex-column justify-center align-center"
                                    :style="{
                                        backgroundColor: card.bg,
                                        border: card.border1,
                                        borderRadius: '16px',
                                        color: '#2e2e2e',
                                        boxShadow: hover ? '0 8px 24px rgba(0, 0, 0, 0.50)' : '',
                                        transform: hover ? 'translateY(-10px)' : 'translateY(0)',
                                        transition: 'all 0.3s ease',
                                        height: '112px',
                                        cursor: 'pointer',
                                        wordWrap: 'break-word',
                                        overflowWrap: 'break-word',
                                        textAlign: 'center',
                                    }">
                                    <div class="text-subtitle-2 font-weight-medium mb-1" style="white-space: normal;">
                                        {{ card.title }}
                                    </div>
                                    <v-btn text color="primary" style="max-width: 100%; white-space: normal;">
                                        {{ card.value }}
                                    </v-btn>
                                </v-card>
                            </v-hover>
                        </div>
                    </div>
                </v-card>

                <br><br>

                <!-- HOMEWORK LIST -->
                <div class="cols-9 pa-3 timeline-wrapper" v-if="homeworkLoading">
                    <v-skeleton-loader type="card" class="mb-4" />
                    <v-skeleton-loader type="card" class="mb-4" />
                </div>
                <div class="cols-9 pa-3 timeline-wrapper" v-else-if="homeworkEntries.length > 0">
                    <v-row class="justify-end mr-10 mb-2">
                        <b>
                            <span @click="toggleHomework" class="link-style">
                                {{ showAllHomework ? 'View Less' : 'View More' }}
                            </span>
                        </b>
                    </v-row>

                    <div class="entries-grid">
                        <div v-for="(entry, index) in visibleHomework" :key="'hw-' + index" class="entry-card"
                            :class="entry.completed ? 'completed-card' : 'pending-card'"
                            @click="call_route_for_homework(entry)">
                            <div :class="['type-label', entry.type]">
                                <span>{{ entry.type }}</span>
                                <span :class="entry.completed ? 'status-completed' : 'status-pending'">
                                    ({{ entry.completed ? 'Completed' : 'Pending' }})
                                </span>
                            </div>
                            <div class="title">{{ entry.title }}</div>
                            <div class="date">{{ entry.post_date }}</div>
                        </div>
                    </div>
                </div>
                <!-- No Homework Fallback -->
                <div v-else class="cols-9">
                    <v-card class="pa-4 text-white" width="100%" elevation="2" rounded="xl">
                        <v-row no-gutters align="center">
                            <v-col cols="12" md="4" class="text-center">
                                <v-img src="https://cdn-icons-png.flaticon.com/256/3426/3426650.png" alt="No Homework"
                                    max-width="100" class="mx-auto mb-4"></v-img>
                            </v-col>
                            <v-col cols="12" md="8" class="text-center text-md-left">
                                <div class="text-h6 font-weight-bold">No homework entries have been added yet!</div>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>

                <br>
                <!-- DIARY LIST -->
                <div class="cols-9 pa-3 timeline-wrapper" v-if="diaryLoading">
                    <v-skeleton-loader type="card" class="mb-4" />
                    <v-skeleton-loader type="card" class="mb-4" />
                </div>
                <div class="cols-9 pa-3 timeline-wrapper" v-else-if="diaryEntries.length > 0">
                    <v-row class="justify-end mr-10 mb-2">
                        <b>
                            <span @click="toggleDiary" class="link-style">
                                {{ showAllDiary ? 'View Less' : 'View More' }}
                            </span>
                        </b>
                    </v-row>

                    <div class="entries-grid">
                        <div v-for="(entry, index) in visibleDiary" :key="'diary-' + index" class="entry-card"
                            @click="call_route_for_diary(entry)">
                            <div :class="['type-label', entry.type]">{{ entry.type }}</div>
                            <div class="title">{{ entry.title }}</div>
                            <div class="date">{{ entry.post_date }}</div>
                        </div>
                    </div>
                </div>
                <!-- No Diary Fallback -->
                <div v-else class="cols-9">
                    <v-card class="pa-4 text-white" width="100%" elevation="2" rounded="xl">
                        <v-row no-gutters align="center">
                            <v-col cols="12" md="4" class="text-center">
                                <v-img src="https://cdn-icons-png.flaticon.com/512/3782/3782354.png" alt="No Diary"
                                    max-width="100" class="mx-auto mb-4"></v-img>
                            </v-col>
                            <v-col cols="12" md="8" class="text-center text-md-left">
                                <div class="text-h6 font-weight-bold">No diary entries have been added yet!</div>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>

                <br>
                <!-- NOTICE LIST -->
                <div class="cols-9 pa-3 timeline-wrapper" v-if="noticeLoading">
                    <v-skeleton-loader type="card" class="mb-4" />
                    <v-skeleton-loader type="card" class="mb-4" />
                </div>
                <div class="cols-9 pa-3 timeline-wrapper" v-else-if="noticeEntries.length > 0">
                    <v-row class="justify-end mr-10 mb-2">
                        <b>
                            <span @click="toggleNotice" class="link-style">
                                {{ showAllNotice ? 'View Less' : 'View More' }}
                            </span>
                        </b>
                    </v-row>

                    <div class="entries-grid">
                        <div v-for="(entry, index) in visibleNotice" :key="'notice-' + index" class="entry-card"
                            @click="call_route_for_notice(entry)">
                            <div :class="['type-label', entry.type]">{{ entry.type }}</div>
                            <div class="title">{{ entry.title }}</div>
                            <div class="date">{{ entry.post_date }}</div>
                        </div>
                    </div>
                </div>
                <!-- No Notice Fallback -->
                <div v-else class="cols-9">
                    <v-card class="pa-4 text-white" width="100%" elevation="2" rounded="xl">
                        <v-row no-gutters align="center">
                            <v-col cols="12" md="4" class="text-center">
                                <v-img src="https://cdn-icons-png.flaticon.com/512/17134/17134606.png" alt="No Notice"
                                    max-width="100" class="mx-auto"></v-img>
                            </v-col>
                            <v-col cols="12" md="8" class="text-center text-md-left">
                                <div class="text-h6 font-weight-bold">No Notices entries have been added yet!</div>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
                <br>
            </div>
        </template>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        components: {},
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            awspath: null,
            showAllHomework: false,
            showAllDiary: false,
            showAllNotice: false,
            ay: null,
            learner: null,
            child_data: [],
            learner_list: [],
            homeworkEntries: [], // from API
            diaryEntries: [],    // from API
            noticeEntries: [],   // from API
            ay_list: [],
            studentInfo: [],
            softCards: [],
            lib_red: null,
            ut: null,
            homeworkLoading: false,
            diaryLoading: false,
            noticeLoading: false,
        }),
        methods: {
            handleCardClick(card) {
                if (card.route) {
                    sessionStorage.removeItem("emp_role");
                    sessionStorage.removeItem("sblinks");
                    sessionStorage.removeItem("para_role");
                    sessionStorage.removeItem("para_role_type");
                    this.$router.push(card.route);
                }
            },
            toggleHomework() {
                this.showAllHomework = !this.showAllHomework;
            },
            toggleDiary() {
                this.showAllDiary = !this.showAllDiary;
            },
            toggleNotice() {
                this.showAllNotice = !this.showAllNotice;
            },
            call_route(route) {
                this.$router.push({ path: '/' + route });
            },
            call_route_for_homework(entry) {
                sessionStorage.setItem("homework_id", entry.homework_id);
                this.$router.push({ path: '/' + entry.route });
            },
            call_route_for_diary(entry) {
                sessionStorage.setItem("diary_id", entry.diary_id);
                sessionStorage.setItem("selected_ay", JSON.stringify(this.ay.id || this.ay));
                sessionStorage.setItem("selected_learner", JSON.stringify(this.learner.id || this.learner));
                sessionStorage.setItem("selected_diarymessagetype", JSON.stringify(entry.diarymessagetype));
                this.$router.push({ path: '/' + entry.route });
            },
            call_route_for_notice(entry) {
                console.log("Notice entry being stored:", entry);
                sessionStorage.setItem("selected_notice", JSON.stringify(entry));
                sessionStorage.setItem("selected_ay", JSON.stringify(this.ay.id || this.ay));
                sessionStorage.setItem("selected_learner", JSON.stringify(this.learner.id || this.learner));
                this.$router.push({ path: '/' + entry.route });
            },
            async call2() {
                this.child_data = [];
                this.homeworkLoading = true;
                this.diaryLoading = true;
                this.noticeLoading = true;
                const data = {
                    ay: this.ay.ay,
                    learner: this.learner,
                };
                try {
                    const res = await axios.post("/parentDashboard/getchildProfiledata", data);
                    if (res.data.flag == "YES") {
                        this.child_data = res.data.child_data;
                        if (res.data.child_data[0].photo_path) {
                            this.learner_photo_path = res.data.child_data[0].photo_path;
                            localStorage.setItem("learner_for_profile", this.learner);
                            localStorage.removeItem("learner_photo_path");
                            localStorage.setItem("learner_photo_path", this.learner_photo_path);
                        }
                        await this.upcomingEvents();
                        await this.getStudentInfo();
                        this.$emit('childEvent', {
                            ay: this.ay,
                            learner: this.learner,
                        });
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                } finally {
                    this.homeworkLoading = false;
                    this.diaryLoading = false;
                    this.noticeLoading = false;
                }
            },
            async upcomingEvents() {
                this.homeworkLoading = true;
                this.diaryLoading = true;
                this.noticeLoading = true;
                const data = {
                    ay: this.ay,
                    learner: this.learner,
                };
                try {
                    const res = await axios.post("/parentDashboard/upcomingEvents_new", data);
                    if (res.data.flag == "YES") {
                        this.noticeEntries = res.data.notice_list || [];
                        this.homeworkEntries = res.data.homework_list || [];
                        this.diaryEntries = res.data.diary_list || [];
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                } finally {
                    this.homeworkLoading = false;
                    this.diaryLoading = false;
                    this.noticeLoading = false;
                }
            },
            async getlearner() {
                this.homeworkLoading = true;
                this.diaryLoading = true;
                this.noticeLoading = true;
                try {
                    const res = await axios.post("/parentDashboard/getchildProfiledata");
                    if (res.data.flag == "YES") {
                        this.ay = res.data.ay;
                        this.ay_list = [...res.data.ay_list].map((ay, index) => ({
                            id: index + 1,
                            ay: ay
                        })).sort((a, b) => {
                            const yearA = parseInt(a.ay.split('-')[0]);
                            const yearB = parseInt(b.ay.split('-')[0]);
                            return yearB - yearA;
                        });
                        this.learner_list = res.data.learner_list;
                        const storedAy = sessionStorage.getItem("selected_ay");
                        const storedLearner = sessionStorage.getItem("selected_learner");
                        if (storedAy) {
                            const ayValue = JSON.parse(storedAy);
                            const validAy = this.ay_list.find(item => item.id == ayValue);
                            this.ay = validAy ? validAy.id : res.data.ay;
                        } else {
                            this.ay = res.data.ay;
                        }
                        if (storedLearner) {
                            const learnerValue = JSON.parse(storedLearner);
                            const validLearner = this.learner_list.find(item => item.id == learnerValue);
                            this.learner = validLearner ? validLearner.id : res.data.learner;
                        } else {
                            this.learner = res.data.learner;
                        }
                        console.log("Initial ay:", this.ay, "Initial learner:", this.learner);
                        this.child_data = res.data.child_data;
                        if (res.data.child_data[0].photo_path) {
                            this.learner_photo_path = res.data.child_data[0].photo_path;
                            localStorage.removeItem("learner_photo_path");
                            localStorage.setItem("learner_photo_path", this.learner_photo_path);
                            localStorage.setItem("learner_for_profile", this.learner);
                        }
                        await this.upcomingEvents();
                        await this.getStudentInfo();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                } finally {
                    this.homeworkLoading = false;
                    this.diaryLoading = false;
                    this.noticeLoading = false;
                }
            },
            async getStudentInfo() {
                this.studentInfo = {};
                const data = {
                    ay: this.ay,
                    lid: this.learner,
                };
                try {
                    const res = await axios.post("/profile/getStudentInfo", data);
                    if (res.data.flag === "YES") {
                        this.studentInfo = res.data;
                        const cards = [];
                        // let grade_persentage = '0';
                        // if (res.data.percentage) {
                        //     grade_persentage = res.data.percentage;
                        // }
        let displayGrade = "--";
        
        // if (res.data.grade_info.grade_name) {
        //     displayGrade = res.data.grade_info.grade_name;
        // }
                        cards.push({
                            title: 'Exam Grade/Marks',
                            value: displayGrade,
                            bg: '#bdedbd',
                            border1: '3px solid #E8F5E9',
                            route: '/analytical-dashboard'
                        });
                        let mealValue = '--';
                        if (res.data.meal_details && res.data.meal_details.length > 0) {
                            // mealValue = res.data.meal_details.map(m => m.name).join(', ');
                             mealValue = res.data.meal_details.length;
                        }
                        cards.push({
                            title: "Today's Meal Menu",
                            value: mealValue,
                            bg: '#D1C4E9',
                            border1: '3px solid #f3e8ff',
                        });
                        let attendancePercentage = '0%';
                        if (res.data.attendance && res.data.attendance.length > 0) {
                            if (res.data.attendance[0].percentage) {
                                attendancePercentage = res.data.attendance[0].percentage;
                            }
                        }
                        cards.push({
                            title: 'Total Attendance',
                            value: attendancePercentage,
                            bg: '#f5e39d',
                            border1: '3px solid #FFFDE7',
                            route: '/analytical-dashboard'
                        });
                        let homeworkAvg = '0.00';
                        if (res.data.home_work_avg) {
                            homeworkAvg = res.data.home_work_avg;
                        }
                        cards.push({
                            title: 'Homework Avg Marks',
                            value: homeworkAvg,
                            bg: '#bdedbd',
                            border1: '3px solid #E8F5E9',
                            route: '/analytical-dashboard'
                        });
                        let transportFee = 0;
                        if (res.data.transport_pending_fee) {
                            transportFee = res.data.transport_pending_fee;
                        }
                        cards.push({
                            title: 'Pending Transport Fees',
                            value: 'Rs. ' + transportFee,
                            bg: '#F8BBD0',
                            border1: '3px solid #FCE4EC',
                            route: '/role-dashboard/online-fee-payment'
                        });
                        let wallet = 0;
                        if (res.data.wallet_balance !== null && res.data.wallet_balance !== undefined) {
                            wallet = res.data.wallet_balance;
                        }
                        cards.push({
                            title: 'Wallet Balance',
                            value: 'Rs. ' + wallet,
                            bg: '#F8BBD0',
                            border1: '3px solid #FCE4EC',
                            route: '/role-dashboard/online-wallet-payment'
                        });
                        let subjects = 0;
                        if (res.data.course_details && res.data.course_details.length > 0) {
                            subjects = res.data.course_details.length;
                        }
                        cards.push({
                            title: 'Current Subjects',
                            value: subjects,
                            bg: '#bdedbd',
                            border1: '3px solid #E8F5E9',
                            route: '/analytical-dashboard'
                        });
                        let pendingRegularFee = 0;
                        if (res.data.pending_fee) {
                            pendingRegularFee = res.data.pending_fee;
                        }
                        cards.push({
                            title: 'Pending Regular Fees',
                            value: 'Rs. ' + pendingRegularFee,
                            bg: '#F8BBD0',
                            border1: '3px solid #FCE4EC',
                            route: '/role-dashboard/online-fee-payment'
                        });
                        // cards.push({
                        //     title: 'Books Borrowed#',
                        //     value: '0',
                        //     bg: '#B2EBF2',
                        //     border1: '3px solid #E0F7FA',
                        // });
                        let quizAvg = '0.00';
                        if (res.data.quiz_avg) {
                            quizAvg = res.data.quiz_avg;
                        }
                        cards.push({
                            title: 'Quiz Avg Marks',
                            value: quizAvg,
                            bg: '#bdedbd',
                            border1: '3px solid #E8F5E9',
                            route: '/analytical-dashboard'
                        });
                        this.softCards = cards;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                } finally {
                    console.log("bye...");
                }
            },
        },
        computed: {
            visibleHomework() {
                return this.showAllHomework ? this.homeworkEntries : this.homeworkEntries.slice(0, 2);
            },
            visibleDiary() {
                return this.showAllDiary ? this.diaryEntries : this.diaryEntries.slice(0, 2);
            },
            visibleNotice() {
                return this.showAllNotice ? this.noticeEntries : this.noticeEntries.slice(0, 2);
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.ut = localStorage.getItem("EPS-ut");
            this.getlearner();
        },
    };
</script>
<style scoped>
    .table-styled {
        border-collapse: collapse;
        width: 100%;
    }

    .row-bordered {
        border: 1px solid #e0e0e0;
    }

    .cell-box {
        text-align: center;
        vertical-align: middle;
        padding: 12px;
        border: 2px solid white;
        vertical-align: top;
        background-color: var(--v-brandLight-base);
        font-size: 14px;
    }

    strong {
        color: #424242;
        font-weight: 600;
    }

    .v-card {
        transition: all 0.3s ease;
    }

    .custom-card-wrapper {
        width: 19%;
        padding: 8px;
        box-sizing: border-box;
    }

    .timeline-wrapper {
        background-color: #e5d9f2;
        border-radius: 10px;
    }

    .side-margin {
        margin-left: 0;
    }

    @media (min-width: 960px) {
        .side-margin {
            margin-left: 90px;
        }
    }

    .responsive-card {
        width: calc(20% - 12px);
        min-width: 160px;
    }

    @media (max-width: 960px) {
        .responsive-card {
            width: calc(33.333% - 12px);
        }
    }

    @media (max-width: 600px) {
        .responsive-card {
            width: 100%;
        }
    }

    .entries-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: space-between;
    }

    .entry-card {
        background: white;
        border-radius: 10px;
        padding: 15px;
        cursor: pointer;
        width: calc(50% - 10px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    }

    .type-label {
        font-weight: bold;
        color: white;
        border-radius: 6px;
        padding: 4px 10px;
        margin-bottom: 8px;
        display: inline-block;
        font-size: 0.85em;
    }

    .Homework {
        background-color: #EC407A;
    }

    .Diary {
        background-color: #388e3c;
    }

    .Notice {
        background-color: #f57c00;
    }

    .title {
        font-size: 17px !important;
        color: #1d3557;
        margin-bottom: 4px;
    }

    .date {
        font-size: 0.85em;
        color: #6c757d;
    }

    .link-style {
        color: #5E35B1;
        cursor: pointer;
        text-decoration: underline;
    }

    .completed-card {
        background-color: #d4edda;
        border-left: 5px solid #28a745;
    }

    .pending-card {
        background-color: #f8d7da;
        border-left: 5px solid #dc3545;
    }

    .status-completed {
        color: #f1f4f2;
        font-weight: bold;
    }

    .status-pending {
        color: #f5eff0;
        font-weight: bold;
    }
</style>